import React, { MouseEvent } from 'react';
import { TTabLabelRenderer } from '../types';
import { useTabsContext } from '../util';
import { Icon, TIconName, isIconName } from '@apia/icons';
import { IconButton, SimpleButton } from '../../components';
import { getLabel } from '@apia/util';
import { observer } from 'mobx-react-lite';

function makeIcon(name: TIconName) {
  return function IconComponent() {
    return <Icon title="" name={name} />;
  };
}

export const DefaultTabsLabelRenderer: TTabLabelRenderer = observer(
  ({ tab }) => {
    const controller = useTabsContext();
    const ActualIcon = React.useMemo(() => {
      if (tab.state.icon) {
        if (isIconName(tab.state.icon)) {
          return makeIcon(tab.state.icon);
        }
        return tab.state.icon;
      }
      return function C() {
        return null;
      };
    }, [tab.state.icon]);

    const handleClose = React.useCallback(
      (ev: MouseEvent) => {
        ev.preventDefault();
        ev.stopPropagation();
        controller?.closeTab(tab.id);
      },
      [controller, tab.id],
    );

    return (
      <>
        {tab.state.isIconTab ? (
          <IconButton
            className="tabs__item__button"
            as="div"
            icon={tab.state.icon as TIconName}
            variant="null"
            iconSize="Sm"
            size="Lg"
          />
        ) : (
          <SimpleButton className="tabs__item__button" as="div" variant="null">
            <ActualIcon />
            {tab.state.label}
          </SimpleButton>
        )}

        {tab.state.isClosable && (
          <IconButton
            as="div"
            onMouseDown={(e) => {
              e.stopPropagation();
              e.preventDefault();
            }}
            onClick={handleClose}
            className="tabs__item__close"
            icon="Close"
            variant="null"
            title={
              getLabel('lblCloseSpecificTab', {
                text: { TOK1: tab.state.label },
              }).text
            }
            size="Lg"
            iconSize="Sm"
          />
        )}
      </>
    );
  },
);
